import type { DepositWithdrawAssets } from '@/shared/types/dictionaryTypes';
import { useDictionary } from '@/shared/api';

const useDepositWithdrawAssetsDictionary = () => {
  const { data, isLoading, error, isError } =
    useDictionary<DepositWithdrawAssets>({
      dictionaryName: 'depositwithdrawassets',
    });

  return {
    depositWithdrawAssetsData: data,
    depositWithdrawAssetsLoading: isLoading,
    depositWithdrawAssetsError: error,
    depositWithdrawAssetsIsError: isError,
  };
};

export { useDepositWithdrawAssetsDictionary };
